import { FormattedMessage } from 'react-intl';

import { Video } from '@sorare/core/src/atoms/icons/Video';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { Chip } from '@sorare/core/src/atoms/ui/Chip';

type Props = { durationInMinutes: number };
export const VideoDuration = ({ durationInMinutes }: Props) => {
  return (
    <Chip>
      <Horizontal gap={0.5}>
        <Video width={12} />
        <FormattedMessage
          defaultMessage="{duration} min"
          values={{ duration: durationInMinutes }}
        />
      </Horizontal>
    </Chip>
  );
};
